import React, { useEffect, useState } from 'react';

const Typewriter = ({ text1, text2, text3, interval = 100, className1 = '', className2 = '', className3 = '', }) => {
  const [visibleText1, setVisibleText1] = useState('');
  const [visibleText2, setVisibleText2] = useState('');
  const [visibleText3, setVisibleText3] = useState('');

  useEffect(() => {
    let index = 0;
    let currentText = text1;
    let currentSetter = setVisibleText1;

    const allTexts = [
      { text: text1, setter: setVisibleText1 },
      { text: text2, setter: setVisibleText2 },
      { text: text3, setter: setVisibleText3 },
    ];

    let textIndex = 0;

    const timer = setInterval(() => {
      if (index < allTexts[textIndex].text.length) {
        allTexts[textIndex].setter(prev => prev + allTexts[textIndex].text[index]);
        index += 1;
      } else {
        textIndex += 1;
        if (textIndex < allTexts.length) {
          index = 0;
        } else {
          clearInterval(timer);
        }
      }
    }, interval);

    return () => clearInterval(timer);
  }, [text1, text2, text3, interval]);

  return (
    <div className="w-full">
      <div className={className1}>{visibleText1}</div>
      <div className={className2}>{visibleText2}</div>
      <div className={className3}>{visibleText3}</div>
    </div>
  );
};

export default Typewriter;
